import React,  { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import { Donor, ApiDonor,  } from '../../models/Donor';
import DonorListItem from './DonorListItem';
import Spinner from '../../components/Spinner';

const NewDonors = () => {
  const [ apiDonors, setApiDonors ] = useState<ApiDonor[]>([]);
  const { post, loading } = useApi();

  useEffect(() => {
    post({
      endpoint: `/api/v1/donors/search`,
      skipAuth: true,
      body: {
        limit: 6,
        sort: 'new'
      },
      onSuccess: (res) => {
        setApiDonors(res?.data || []);
      },
      onError: (err) => {
        console.error(err.message);
      },
    });
  }, [ post ])

  const donorItems = apiDonors.map(apiDonor => {
    const donor = new Donor(apiDonor);

    return <DonorListItem key={ donor.userNo } donor={ donor } />
  });

  return (
      <section className="new_donor">
        <h2 className="main_title"><span>新着登録ドナー</span></h2>
        <ul>
          { loading ? <Spinner centered /> : donorItems }
        </ul>
      </section>
  );
}

export default NewDonors;
